function Restrictions(props) {
  return <>Restrictions</>;
}

export default Restrictions;
